import { marketingAgentPromptSchema } from "@redotech/redo-marketing-templates-common/marketing/marketing-agent-prompt/marketing-agent-prompt-definition";
import * as z from "zod";

/**
 * RPC schema for retrieving all marketing agent prompts.
 */
export const getAllMarketingAgentPrompts = {
  name: "getAllMarketingAgentPrompts" as const,
  input: z.object({}),
  output: z.object({
    success: z.boolean(),
    message: z.string().optional(),
    prompts: z.array(marketingAgentPromptSchema),
  }),
};
